<template>
  <div>
    <transition name="fade">
      <div class="global-modal" v-show="show">
        <div class="global-modal-content">
          <div class="payout-form">
            <div class="title">
              <span v-if="trxId === null">NEW TRANSACTION</span>
              <span v-else>EDITING TRANSACTION</span>
            </div>
            <div class="form-fields">

              <div class="row">
                <div class="small-6 columns padding-L padding-R">
                  <div class="field-input">
                    <label>TYPE</label>
                    <select v-model="trxType">
                      <option value="credit">Credit</option>
                      <option value="debit">Debit</option>
                    </select>
                  </div>
                </div>

                <div class="small-6 columns padding-L padding-R">
                  <div class="field-input">
                    <label>TRANSACTION TYPE</label>
                    <select v-model="trxTransactionType">
                      <option value="completed">Completed</option>
                      <option value="noshow">No Show</option>
                      <option value="release_fee">Release Fee</option>
                      <option value="chargeback">Chargeback</option>
                      <option value="deduction">Deduction</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>

              </div>

              <div class="row margin-T">
                <div class="small-12 columns padding-L padding-R">
                  <div class="field-input">
                    <label>DESCRIPTION</label>
                    <textarea v-model="trxDescription"></textarea>
                  </div>
                </div>
              </div>


              <div class="row margin-T">
                <div class="small-4 columns padding-L padding-R">
                  <div class="field-input">
                    <label>AMOUNT</label>
                    <input type="number" placeholder="0" v-model="trxAmount" />
                  </div>
                </div>
                <div class="small-4 columns padding-L padding-R">
                  <div class="field-input">
                    <label>RESERVATION ID</label>
                    <input v-bind:class="{ disabled: rsvpValid !== null && rsvpValid.validating }"
                           type="text" placeholder="123456" v-model="trxReservationId" @change="validateRsvp" />
                    <i class="fa fa-spinner fa-spin" v-show="rsvpValid !== null && rsvpValid.validating"></i>
                    <i class="fa fa-check" v-show="rsvpValid !== null && trxReservationId !== null && trxReservationId !== '' && !rsvpValid.validating && rsvpValid.isValid"></i>
                    <i class="fa fa-exclamation-circle" v-show="rsvpValid !== null && trxReservationId !== null && trxReservationId !== '' && !rsvpValid.validating && !rsvpValid.isValid"></i>
                  </div>
                </div>
                <div class="small-4 columns padding-L padding-R">
                  <div class="field-input">
                    <label>PACKAGE ID</label>
                    <input v-bind:class="{ disabled: packageValid !== null && packageValid.validating }"
                           type="text" placeholder="123456" v-model="trxPackageId" @change="validatePackage" />
                    <i class="fa fa-spinner fa-spin" v-show="packageValid !== null && packageValid.validating"></i>
                    <i class="fa fa-check"
                       v-show="packageValid !== null && trxReservationId !== null && trxReservationId !== '' && !packageValid.validating && packageValid.isValid"></i>
                    <i class="fa fa-exclamation-circle"
                       v-show="packageValid !== null && trxReservationId !== null && trxReservationId !== '' && !packageValid.validating && !packageValid.isValid"></i>
                  </div>
                </div>
              </div>

              <div class="row margin-T">
                <div class="small-12 columns padding-L padding-R">
                  <div class="field-input">
                    <label>NOTE TO DRIVER</label>
                    <textarea v-model="trxNotes"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="error-message" v-show="error.show">{{ error.message }}</div>
            <div class="controls">
              <a v-bind:class="{ 'button cta xsmall warning margin-R': true, disabled: saving }" href="javascript:;" @click="hidePayoutForm">CANCEL</a>
              <a v-bind:class="{ 'button cta xsmall success margin-L': true,
                                  disabled: saving || (rsvpValid !== null && rsvpValid.validating) || (packageValid !== null && packageValid.validating) }"
                 href="javascript:;" @click="save">
                <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                <span v-else>SAVE</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="global-modal" v-show="notes.show">
        <div class="global-modal-content">
          <div class="payout-notes">
            <div class="message">{{ notes.note }}</div>
            <a class="button cta xsmall" href="javascript:;" @click="closeNotes">CLOSE</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ApiPayouts from '../../modules/api/provider/payouts'
export default {
  name: 'payout-form',
  props: [ 'provId' ],
  data () {
    return {
      saving: false,
      error: {
        show: false,
        message: ''
      },
      rsvpValid: null,
      packageValid: null
    }
  },
  computed: {
    notes () { return this.$store.state.provider.payoutNotes },
    show () { return this.$store.state.provider.payoutForm.show },
    trxId () { return this.$store.state.provider.payoutForm.form.id },
    trxType: {
      get () { return this.$store.state.provider.payoutForm.form.type },
      set (value) { this.$store.commit('provider/setPayoutFormType', value) }
    },
    trxTransactionType: {
      get () { return this.$store.state.provider.payoutForm.form.transactionType },
      set (value) { this.$store.commit('provider/setPayoutFormTransactionType', value) }
    },
    trxAmount: {
      get () { return this.$store.state.provider.payoutForm.form.amount },
      set (value) { this.$store.commit('provider/setPayoutFormAmount', value) }
    },
    trxDescription: {
      get () { return this.$store.state.provider.payoutForm.form.description },
      set (value) { this.$store.commit('provider/setPayoutFormDescription', value) }
    },
    trxNotes: {
      get () { return this.$store.state.provider.payoutForm.form.notes },
      set (value) { this.$store.commit('provider/setPayoutFormNotes', value) }
    },
    trxReservationId: {
      get () { return this.$store.state.provider.payoutForm.form.reservationId },
      set (value) { this.$store.commit('provider/setPayoutFormReservationId', value) }
    },
    trxPackageId: {
      get () { return this.$store.state.provider.payoutForm.form.packageId },
      set (value) { this.$store.commit('provider/setPayoutFormPackageId', value) }
    }
  },
  methods: {
    validatePackage () {
      let self = this
      if (self.trxPackageId === null || self.trxPackageId === '') {
        self.packageValid = {
          validating: false,
          isValid: true
        }
        return
      }

      self.packageValid = {
        validating: true,
        isValid: false
      }
      self.$sdk.get('/admin/package/' + self.trxPackageId, {
        token: self.$store.state.session.sessionToken
      }, r => {
        console.log(r)
        self.packageValid.validating = false
        if (r.error) {
          self.packageValid.isValid = false
          return
        }
        self.packageValid.isValid = true
      })
    },
    validateRsvp () {
      let self = this
      if (self.trxReservationId === null || self.trxReservationId === '') {
        self.rsvpValid = {
          validating: false,
          isValid: true
        }
        return
      }

      self.rsvpValid = {
        validating: true,
        isValid: false
      }
      self.$sdk.get('/admin/rsvp/' + self.trxReservationId, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.rsvpValid.validating = false
        if (r.error) {
          self.rsvpValid.isValid = false
          return
        }
        self.rsvpValid.isValid = true
      })
    },
    isValid () {
      let self = this
      self.error.show = false
      self.error.message = ''
      if (self.trxAmount <= 0) {
        self.error.show = true
        self.error.message = 'Amount must be greater than 0.'
        return false
      }

      if (self.trxDescription === null || self.trxDescription === '') {
        self.error.show = true
        self.error.message = 'Description is required.'
        return false
      }

      if (self.rsvpValid !== null && !self.rsvpValid.isValid) {
        self.error.show = true
        self.error.message = 'Reservation ' + self.trxReservationId + ' does not exist.'
        return false
      }

      if (self.packageValid !== null && !self.packageValid.isValid) {
        self.error.show = true
        self.error.message = 'Package ' + self.trxPackageId + ' does not exist.'
        return false
      }

      return true
    },
    hidePayoutForm () { this.$store.commit('provider/setPayoutFormShow', false) },
    save () {
      let self = this
      if (!self.isValid()) {
        return
      }
      self.saving = true
      let request = {
        token: self.$store.state.session.sessionToken,
        type: self.trxType,
        transactionType: self.trxTransactionType,
        amount: self.trxAmount,
        description: self.trxDescription,
        notes: self.trxNotes === '' ? null : self.trxNotes,
        reservationId: self.trxReservationId === '' ? null : self.trxReservationId,
        packageId: self.trxPackageId === '' ? null : self.trxPackageId
      }

      let callback = r => {
        self.saving = false
        self.$store.commit('provider/setPayoutFormRefresh', true)
        self.hidePayoutForm()
      }
      if (self.trxId === null) {
        ApiPayouts.createTransaction(self, self.provId, request, callback)
        return
      }
      ApiPayouts.updateTransaction(self, self.trxId, request, callback)
    },
    closeNotes () {
      let self = this
      self.$store.commit('provider/setPayoutNotes', {
        show: false,
        note: ''
      })
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }

      self.rsvpValid = null
    }
  }
}
</script>

<style lang="scss" scoped>
.payout-form {
  width: 500px;
  margin: 0 auto;
  border-radius: 3px;
  font-size: 14px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  overflow: hidden;

  & .title {
    text-align: center;
    color: #fff;
    font-weight: 700;
    background-color: #0D79F2;
    padding: 10px 0;
  }

  & .controls {
    text-align: center;
    padding: 5px 0 15px;

    & .button { width: 80px; }
  }
}

.form-fields { padding: 10px 8px; }

.field-input {
  position: relative;
  & label {
    font-size: 10px;
    font-weight: 700;
    color: #0D79F2;
  }
  & select{
    margin-top: 0;
    border: 1px solid #ccc;
    padding: 10px;
    color: #333;
    height: 40px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('/assets/img/down.png') no-repeat 200px 9px;
    transition: all .35s ease;
  }

  & input {
    margin-top: 0;
    padding: 8px 10px 9px;

    &.disabled {
      pointer-events: none;
      background-color: #eee;
    }
  }

  & textarea {
    margin-top: 0;
    resize: none;
    height: 80px;
  }

  & i {
    position: absolute;
    top: 35px;
    right: 15px;

    &.fa-check { color: #26D97A; }
    &.fa-exclamation-circle { color: #F20D0D; }
  }
}

.error-message {
  border: 1px solid #F20D0D;
  color: #F20D0D;
  padding: 10px;
  font-size: 13px;
  border-radius: 3px;
  text-align: center;
  margin: 5px 15px 10px;
}

.payout-notes {
  width: 300px;
  margin: 0 auto;
  border-radius: 3px;
  font-size: 14px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  overflow: hidden;
  padding: 15px;
  text-align: center;
  & .message {
    margin-bottom: 10px;
  }
}

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 10px; }
.margin-L { margin-left: 5px; }
.margin-R { margin-right: 5px; }
</style>



// WEBPACK FOOTER //
// src/components/Provider/PayoutForm.vue